export default "__VITE_ASSET__BAecsU_C__"